import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Message from './../shared/Message';
import useDashboardStats from '../../hooks/useDashboardStats';
import CustomLoader from '../shared/CustomLoader';
import RecentActivityTable from './../shared/ReactActivityTable';
import StatCard from '../shared/StatCard';
import { FaMapLocationDot, FaShieldHeart, FaUsers, FaUserShield } from 'react-icons/fa6';
import AttendanceChart from '../shared/AttendanceChart';

const Dashboard = () => {
  const { stats, loading, errorMessage, setErrorMessage, refresh } = useDashboardStats();

  const handleCloseError = () => setErrorMessage(prev => ({...prev, show: false}));

  if(loading) return <div className="py-5"><CustomLoader /></div>
  return (
    <Container fluid className='py-4 px-4'>

      {/** Display custom Message component if an error occurs */}
      <Message
        show={errorMessage.show}
        variant={errorMessage.variant}
        message={errorMessage.text}
        handleClose={handleCloseError}
      />

     <h2 className='fw-bold mb-4'>Operational Overview</h2>

     {/** 1. The Stats Cards Row */}
     <Row className='g-4 mb-5'>

        <Col xl={3} md={6}>
          <StatCard
            title='Incidents'
            value={stats.incident_reports.current}
            percentage={stats.incident_reports.percentage}
            isIncrease={stats.incident_reports.is_increase}
            inverse={true}
            icon={FaShieldHeart}
          />

        </Col>

        <Col xl={3} md={6}>
          <StatCard
            title='Clients'
            value={stats.clients.current}
            percentage={stats.clients.percentage}
            isIncrease={stats.clients.is_increase}
            inverse={false}
            icon={FaUsers}
          />

        </Col>

        <Col xl={3} md={6}>
          <StatCard
            title='Sites'
            value={stats.sites.current}
            percentage={stats.sites.percentage}
            isIncrease={stats.sites.is_increase}
            inverse={false}
            icon={FaMapLocationDot}
          />

        </Col>

        <Col xl={3} md={6}>
          <StatCard
            title='Security Officers'
            value={stats.employees.current}
            percentage={stats.employees.percentage}
            isIncrease={stats.employees.is_increase}
            inverse={false}
            icon={FaUserShield}
          />

        </Col>

     </Row>

     {/** 2. The Recent Activity Table */}
     <Row className='mt-4'>
        
        {/** 70% Width for the Activity Table */}
        <Col lg={8} className='mb-4'>
          <RecentActivityTable incidents={stats?.recent_incidents} />
        </Col>

        {/** 30% Width for the Attendance Chart */}
        <Col lg={4} className='mb-4'>
          <AttendanceChart chartData={stats?.attendance_chart} />
        </Col>

     </Row>

    </Container>
  )
}

export default Dashboard